import { configureStore } from "@reduxjs/toolkit";

import userReducer from "slices/user";
import officersReducer from "slices/officers";

export default configureStore({
  reducer: {
    user: userReducer,
    officers: officersReducer
  },
});
